import React from 'react'
import { css } from 'glamor'

let divStyle = css({
  paddingTop: '40px',
  textAlign: 'center',
})

let linkStyle = css({
  color: '#fffffff0',
  textDecoration: 'none',
  ':hover': {
    color: '#cfcfcf',
  }
})

const Releases = () => (
  <div className={divStyle}>
    <p>Our full label discography is available for stream and purchase on our bandcamp page:
    <br/>
    <a className={linkStyle} href="https://voodoodown.bandcamp.com/" target="_blank">https://voodoodown.bandcamp.com</a></p>
  </div>
)

export default Releases



// WEBPACK FOOTER //
// ./src/pages/releases.js